/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：708
 */

module.exports = {
  sliderImageDialog: "styles_sliderImageDialog__1fFwX",
  sliderImage: "styles_sliderImage__VjS9Q",
  title: "styles_title__3FgDA",
  sliderPreview: "styles_sliderPreview__2fiG1",
  previewBox: "styles_previewBox__3pfx8",
  backgroundImage: "styles_backgroundImage__1RNBS",
  trackImageBox: "styles_trackImageBox__3DgxW",
  trackImage: "styles_trackImage__2O9fr",
  handleImage: "styles_handleImage__2YQya",
  vertical: "styles_vertical__Spn7n",
  imageInfo: "styles_imageInfo__2qEie",
  imageList: "styles_imageList__1Dph5",
  imageItem: "styles_imageItem__3T2Rd",
  imageItemBox: "styles_imageItemBox__vRRIH",
  image: "styles_image__qus1j",
  cover: "styles_cover__2o0tk",
  replaceBtn: "styles_replaceBtn__6RYwg",
  handleSize: "styles_handleSize__11azw",
  sizeLabel: "styles_sizeLabel__1Uu9T",
  imagePopover: "styles_imagePopover__3Uotu",
  content: "styles_content__248-b",
  contentTitle: "styles_contentTitle__2rqQw"
}
